import { useCallback, useEffect, useState } from "react";
import { getSVCUploadHistory } from "../../API/svcUploadHistory.Api";
//import config from "../../../config";

export const useUploadHistory = () => {
    const [uploadHistory, setUploadHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
   

    const fetchUploadHistory = useCallback(async () => {
        try{

           
            const data = await getSVCUploadHistory();
            setUploadHistory(data || []);
        } catch (error) {
            console.error("Error fetching upload history:", error); 
        } finally {
            setLoading(false);
        }
        // console.log("page fetchUploadHistory", page)
        // setTotalPages(data.totalPages || config.amountPages);
        // setTotalPages(29);
        // console.log("data.totalPages", data)
    }, []);
    const fetchFilterUploads = useCallback( async (params) => {
        try{

           
            let data;
            if(params){
            data = await getSVCUploadHistory(params);
            }
            return data;
            // setUploadHistory(data || []);
            // setUploadHistory(data || []);
            // setTotalPages(data.totalPages || config.amountPages);
            // setTotalPages(29);
        }catch (error) {
            console.error("Error fetching upload history:", error); 
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchUploadHistory();
    }, [fetchUploadHistory]);

     useEffect(() => {
        fetchFilterUploads();
    }, [fetchFilterUploads]);

    return {
        fetchUploadHistory,
        fetchFilterUploads,
        uploadHistory,
        page,
        setPage,
        loading
    
    };
};
